export default __webpack_public_path__ + "b9f5aec3111ac80711fd287211b504bc.jpg";